import { showVideoList } from "@/api";
import { getListOne } from "@/utils/tools";
import CompVideo from './video.vue';
import { domClientWidth, domPixelRatio } from "md-base-tools/env";
export default {
  props: {
    product_info: {
      // 项目详情
      type: Object
    }
  },
  components: {
    CompVideo
  },
  computed: {
    imgWidth() {
      return Math.round(domClientWidth() * domPixelRatio());
    }
  },
  data() {
    return {
      videoUrl: '',
      if_video_play: false,
      currentIndex: 1
    };
  },
  methods: {
    // 播放视频
    async playVideo() {
      if (this.product_info.video_info && this.currentIndex == 1) {
        var _this$product_info, _this$product_info$vi;
        const res = await showVideoList({
          url: (_this$product_info = this.product_info) === null || _this$product_info === void 0 ? void 0 : (_this$product_info$vi = _this$product_info.video_info) === null || _this$product_info$vi === void 0 ? void 0 : _this$product_info$vi.video_source
        });
        if (res.status == 0) {
          let defaultValue = res.data.default ? res.data.default : getListOne(res.data.list);
          let new_src = res.data.list[defaultValue];
          this.videoUrl = new_src;
          this.if_video_play = true;
        }
      }
    },
    swiperChange(index) {
      this.currentIndex = index + 1;
    },
    showImg() {
      this.if_video_play = false;
    }
  }
};